import * as footerStyles from "./footer.module.scss";
import { Link, graphql, useStaticQuery } from "gatsby";
import React from "react";
import dribble from "../../images/home/dribbble.svg";
import behance from "../../images/home/behance.svg";
import twitter from "../../images/home/twitter.svg";
import facebook from "../../images/home/facebook.svg";
import linkedIn from "../../images/home/linkedIn.svg";
import instagram from "../../images/home/instagram.svg";
import usFlag from "../../images/home/us_flag.png";
import indiaFlag from "../../images/home/india_flag.png";

export default function Footer() {
  const data = useStaticQuery(graphql`
    query {
      item1: allWpMenu(filter: { id: { eq: "dGVybTo1MQ==" } }) {
        edges {
          node {
            menuItems {
              nodes {
                label
                url: uri
              }
            }
          }
        }
      }
      item2: allWpMenu(filter: { id: { eq: "dGVybTo1Mg==" } }) {
        edges {
          node {
            menuItems {
              nodes {
                label
                url: uri
              }
            }
          }
        }
      }
    }
  `);

  const footerMenu = data?.item1?.edges[0]?.node.menuItems.nodes || [];
  const footerMenu2 = data?.item2?.edges[0]?.node.menuItems.nodes || [];

  return (
    <footer className={footerStyles.footerWrap}>
      <div className={footerStyles.container}>
        <div className={footerStyles.footerContentWrap}>
          <div className={footerStyles.footerContent}>
            <p>
              Crafting UI/UX is sculpting the bridge between users and
              technology, fostering a connection that is intuitive, delightful,
              and unforgettable.
            </p>
            <div>
              <ul className={footerStyles.socialIcons}>
                <li>
                  <a
                    rel="noopener noreferrer"
                    aria-label="Visit Dribbble"
                    href="https://dribbble.com/design-studio"
                    target="_blank"
                    className={`${footerStyles.iconBox} ${footerStyles.dribble}`}
                  >
                    <div className={footerStyles.iconWrap}>
                      <div className={footerStyles.iconImage}>
                        <img src={dribble} alt="dribble" />
                      </div>
                      <div className={footerStyles.hoverImage}>
                        <img src={dribble} alt="dribble" />
                      </div>
                    </div>
                    <span className={footerStyles.iconBg}></span>
                  </a>
                </li>
                <li>
                  <a
                    rel="noopener noreferrer"
                    aria-label="Visit Behance"
                    href="https://www.behance.net/designstudioind"
                    target="_blank"
                    className={`${footerStyles.iconBox} ${footerStyles.behance}`}
                  >
                    <div className={footerStyles.iconWrap}>
                      <div className={footerStyles.iconImage}>
                        <img src={behance} alt="behance" />
                      </div>
                      <div className={footerStyles.hoverImage}>
                        <img src={behance} alt="behance" />
                      </div>
                    </div>
                    <span className={footerStyles.iconBg}></span>
                  </a>
                </li>
                <li>
                  <a
                    rel="noopener noreferrer"
                    aria-label="Visit Twitter"
                    href="https://twitter.com/design__studio"
                    target="_blank"
                    className={`${footerStyles.iconBox} ${footerStyles.twitter}`}
                  >
                    <div className={footerStyles.iconWrap}>
                      <div className={footerStyles.iconImage}>
                        <img src={twitter} alt="twitter" />
                      </div>
                      <div className={footerStyles.hoverImage}>
                        <img src={twitter} alt="twitter" />
                      </div>
                    </div>
                    <span className={footerStyles.iconBg}></span>
                  </a>
                </li>
                <li>
                  <a
                    rel="noopener noreferrer"
                    aria-label="Visit Facebook"
                    href="https://www.facebook.com/designstudio.io/"
                    target="_blank"
                    className={`${footerStyles.iconBox} ${footerStyles.facebook}`}
                  >
                    <div className={footerStyles.iconWrap}>
                      <div className={footerStyles.iconImage}>
                        <img src={facebook} alt="facebook" />
                      </div>
                      <div className={footerStyles.hoverImage}>
                        <img src={facebook} alt="facebook" />
                      </div>
                    </div>
                    <span className={footerStyles.iconBg}></span>
                  </a>
                </li>
                <li>
                  <a
                    rel="noopener noreferrer"
                    aria-label="Visit Linkedin"
                    href="https://www.linkedin.com/company/design-studio-india/"
                    target="_blank"
                    className={`${footerStyles.iconBox} ${footerStyles.linkedIn}`}
                  >
                    <div className={footerStyles.iconWrap}>
                      <div className={footerStyles.iconImage}>
                        <img src={linkedIn} alt="linkedIn" />
                      </div>
                      <div className={footerStyles.hoverImage}>
                        <img src={linkedIn} alt="linkedIn" />
                      </div>
                    </div>
                    <span className={footerStyles.iconBg}></span>
                  </a>
                </li>
                <li>
                  <a
                    rel="noopener noreferrer"
                    aria-label="Visit Instagram"
                    href="https://www.instagram.com/uiux.designstudio/"
                    target="_blank"
                    className={`${footerStyles.iconBox} ${footerStyles.instagram}`}
                  >
                    <div className={footerStyles.iconWrap}>
                      <div className={footerStyles.iconImage}>
                        <img src={instagram} alt="instagram" />
                      </div>
                      <div className={footerStyles.hoverImage}>
                        <img src={instagram} alt="instagram" />
                      </div>
                    </div>
                    <span className={footerStyles.iconBg}></span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className={footerStyles.footerContentRight}>
            <div className={footerStyles.addressBlockWrap}>
              <div className={footerStyles.addressBlock}>
                <div className={footerStyles.flagBlock}>
                  <img src={usFlag} alt="usFlag" />
                  <span>USA</span>
                </div>
                <address className={footerStyles.address}>
                  82-21 150th Avenue , DEL 117 SpringfieldGardens, NY Zip Code:
                  11413
                </address>
              </div>
              <div className={footerStyles.addressBlock}>
                <div className={footerStyles.flagBlock}>
                  <img src={indiaFlag} alt="indiaFlag" />
                  <span>India</span>
                </div>
                <address className={footerStyles.address}>
                  Webel STP II Building, 53, DN Block, Sector V, Bidhannagar,
                  Kolkata, West Bengal 700091
                </address>
              </div>
            </div>
          </div>
        </div>
        <div className={footerStyles.footerBottom}>
          <div className={footerStyles.footerBottomleft}>
            <ul>
              {footerMenu.map((item, index) => (
                <li key={index}>
                  <Link to={item.url}>{item.label}</Link>
                </li>
              ))}
              {footerMenu2.map((item, index) => (
                <li key={index}>
                  <Link to={item.url}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className={footerStyles.footerBottomright}>
            <span>© {new Date().getFullYear()} Design Studio UI UX | All Rights Reserved</span>
          </div>
        </div>
      </div>
      <div className={footerStyles.footerLogoBottom}></div>
    </footer>
  );
}
